import { useNavigation } from '@/navigation/NavigationContex';
import { AccordionItem } from '../../components/AccordionItem';
import { AccordionItemContent } from '../../components/AccordionItemContent';
import { AccordionItemHeader } from '../../components/AccordionItemHeader';
import { translate } from '@/translation/translate.ts';
import { RenderField } from '@/form/fields/RenderField';

const AncestryHispanic = () => {
  const { currentSlide } = useNavigation();

  const ancestryMexican = currentSlide!.fields.find(({ name }) => name === 'ancestryMexican');
  const ancestryCuban = currentSlide!.fields.find(({ name }) => name === 'ancestryCuban');
  const ancestryPuertoRican = currentSlide!.fields.find(({ name }) => name === 'ancestryPuertoRican');
  const ancestryOtherHispanic = currentSlide!.fields.find(({ name }) => name === 'ancestryOtherHispanic');

  return (
    <AccordionItem>
      <AccordionItemHeader>{translate(currentSlide?.titles?.hispanic)}</AccordionItemHeader>
      <AccordionItemContent>
        <RenderField slideId={currentSlide!.id} field={ancestryMexican!} />
        <RenderField slideId={currentSlide!.id} field={ancestryCuban!} />
        <RenderField slideId={currentSlide!.id} field={ancestryPuertoRican!} />
        <RenderField slideId={currentSlide!.id} field={ancestryOtherHispanic!} />
      </AccordionItemContent>
    </AccordionItem>
  );
};

export default AncestryHispanic;
